/* Andy Cooks – Cook Mode: full screen steps, tap/swipe, read aloud, voice commands, timers */
(function () {
  'use strict';
  var acT = function (k, f, v) { var s = (window.AC_I18N && window.AC_I18N[k]) || f; if (v) { for (var n in v) { s = s.split('__' + n + '__').join(v[n]); } } return s; };
  var A = window.__acr;
  if (!A) return;
  var root = A.root, stepLis = A.stepLis, markNext = A.markNext, setPageIndex = A.setPageIndex, cookBtn = A.cookBtn;
  var getPrefs = A.getPrefs || function () { return { serves: 0, base: 0, system: 'metric' }; };

  /* ================= COOK MODE: full screen, tap anywhere, read aloud, voice commands, timers ================= */
  function stepText(li) {
    var clone = li.cloneNode(true);
    [].slice.call(clone.querySelectorAll('.acr-num, .acr-sr, .acr-nextbtn, .acr-stephint, img')).forEach(function (n) { n.parentNode.removeChild(n); });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }
  var steps = stepLis.map(function (li) {
    var ol = li.parentNode, h = ol.previousElementSibling;
    return {
      heading: h && h.classList.contains('acr-h3') ? h.textContent.trim() : '',
      text: stepText(li)
    };
  });
  if (!cookBtn || !steps.length) return;

  var titleText = (root.querySelector('.acr-title') || {}).textContent || document.title;
  var I = {
    mic: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21M8.5 21h7"/></svg>',
    basket: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 10.5h18l-1.9 8.6a2 2 0 0 1-2 1.6H6.9a2 2 0 0 1-2-1.6z"/><path d="M6.3 10.5a3.6 3.6 0 0 1 7.2 0"/><path d="M8.5 13.8v3.8M11.5 13.8v3.8M14.5 13.8v3.8"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    down: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v13M6 12l6 6 6-6"/></svg>',
    tick: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7"/></svg>',
    right: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6"/></svg>',
    clock: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2M9.5 2.5h5"/></svg>'
  };
  var cm = document.createElement('div');
  cm.className = 'acm';
  cm.hidden = true;
  cm.setAttribute('role', 'dialog');
  cm.setAttribute('aria-modal', 'true');
  cm.setAttribute('aria-label', acT('ac.js.cook_mode.cook_mode', 'Cook mode'));
  cm.innerHTML =
    '<div class="acm__top">' +
      '<div class="acm__meta"><span class="acm__title"></span><span class="acm__count"></span></div>' +
      '<div class="acm__tools">' +
        '<button type="button" class="acm__tool acm__tool--voice" data-acm="voice" aria-pressed="false">' + I.mic + '<span class="acm__tool-l">' + acT('ac.js.cook_mode.hands_free', 'Hands-free') + '</span></button>' +
        '<button type="button" class="acm__tool" data-acm="ing" aria-expanded="false">' + I.basket + '<span class="acm__tool-l">' + acT('ac.js.cook_mode.ingredients', 'Ingredients') + '</span></button>' +
        '<button type="button" class="acm__close" data-acm="close" aria-label="' + acT('ac.js.cook_mode.close_cook_mode', 'Close cook mode') + '">' + I.close + '</button>' +
      '</div>' +
    '</div>' +
    '<div class="acm__progress" aria-hidden="true"><span></span></div>' +
    '<div class="acm__stage" data-acm="stage">' +
      '<div class="acm__setup">' +
        '<p class="acm__heading">' + acT('ac.js.cook_mode.before_you_start', 'Before you start') + '</p>' +
        '<p class="acm__setup-q" aria-live="polite"></p>' +
        '<div class="acm__setup-ctrls">' +
          '<div class="acm__field acm__field--serves"><span class="acm__field-l">' + acT('ac.js.cook_mode.cooking_for', 'Cooking for') + '</span>' +
            '<div class="acm__stepper"><button type="button" data-acm="serves-" aria-label="' + acT('ac.js.cook_mode.fewer_people', 'Fewer people') + '">&minus;</button>' +
            '<output class="acm__serves-out"></output>' +
            '<button type="button" data-acm="serves+" aria-label="' + acT('ac.js.cook_mode.more_people', 'More people') + '">+</button></div></div>' +
          '<div class="acm__field"><span class="acm__field-l">' + acT('ac.js.cook_mode.measurements', 'Measurements') + '</span>' +
            '<div class="acm__seg" role="radiogroup" aria-label="' + acT('ac.js.cook_mode.measurements', 'Measurements') + '">' +
          '<button type="button" role="radio" data-acm="sys-metric">' + acT('ac.js.cook_mode.metric', 'Metric') + '</button>' +
          '<button type="button" role="radio" data-acm="sys-imperial">' + acT('ac.js.cook_mode.imperial', 'Imperial') + '</button>' +
        '</div>' +
          '</div>' +
        '</div>' +
        '<p class="acm__setup-note">' + acT('ac.js.cook_mode.setup_note', 'Ingredient amounts update to match. You can check or change them any time under Ingredients.') + '</p>' +
      '</div>' +
      '<p class="acm__heading acm__heading--step"></p>' +
      '<div class="acm__step"><span class="acm__num" aria-hidden="true"></span><p class="acm__text" aria-live="polite"></p></div>' +
      '<div class="acm__timers"></div>' +
      '<p class="acm__hint"></p>' +
    '</div>' +
    '<p class="acm__heard" aria-hidden="true"></p>' +
    '<div class="acm__running" aria-live="polite"></div>' +
    '<div class="acm__nav">' +
      '<button type="button" class="acm__back" data-acm="back">' + acT('ac.js.cook_mode.back', 'Back') + '</button>' +
      '<button type="button" class="acm__next" data-acm="next"></button>' +
    '</div>' +
    '<aside class="acm__ing" hidden aria-label="' + acT('ac.js.cook_mode.ingredients', 'Ingredients') + '">' +
      '<div class="acm__ing-head"><h3>' + acT('ac.js.cook_mode.ingredients', 'Ingredients') + '</h3>' + '<div class="acm__seg acm__seg--sm" role="radiogroup" aria-label="' + acT('ac.js.cook_mode.measurements', 'Measurements') + '">' +
          '<button type="button" role="radio" data-acm="sys-metric">' + acT('ac.js.cook_mode.metric', 'Metric') + '</button>' +
          '<button type="button" role="radio" data-acm="sys-imperial">' + acT('ac.js.cook_mode.imperial', 'Imperial') + '</button>' +
        '</div>' + '<button type="button" class="acm__close" data-acm="ing-close" aria-label="' + acT('ac.js.cook_mode.close_ingredients', 'Close ingredients') + '">' + I.close + '</button></div>' +
      '<ul></ul>' +
    '</aside>';
  document.body.appendChild(cm);
  var float = document.createElement('div');
  float.className = 'act-float';
  float.setAttribute('aria-live', 'polite');
  document.body.appendChild(float);

  function $(sel) { return cm.querySelector(sel); }
  var idx = 0, finished = false, setup = false;
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  var synth = window.speechSynthesis || null;
  var voiceOn = false, rec = null, recActive = false, speaking = false, introDone = false, micBlocked = false;
  var lock = null, audio = null;

  /* ---- wake lock ---- */
  function acquire() { if ('wakeLock' in navigator) navigator.wakeLock.request('screen').then(function (l) { lock = l; }).catch(function () {}); }
  function release() { if (lock) { lock.release().catch(function () {}); lock = null; } }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && !cm.hidden) acquire(); });

  /* ---- speech out ---- */
  var voice = null;
  function pickVoice() {
    if (!synth) return;
    /* Andy is a Kiwi: a New Zealand male voice if the device has one (e.g. Edge's "Mitchell"), otherwise the closest
       male voice (Australian > British > other English), then the best-sounding female voice as a last resort.
       Which voices exist depends on the visitor's device and browser; the site can't add voices of its own. */
    var vs = synth.getVoices().filter(function (v) { return /^en/i.test(v.lang); });
    var MALE = /\b(Mitchell|Lee|William|Daniel|Ryan|Guy|Thomas|Arthur|Oliver|Gordon|Ken|Darren|Duncan|Tom|Aaron|Alex|Rishi|Liam|Christopher|Eric|Brian|Andrew|Davis|Steffan|Tony|Jason|Roger)\b|\bmale\b/i;
    var FEMALE = /\b(Molly|Karen|Catherine|Natasha|Serena|Kate|Libby|Sonia|Jenny|Aria|Samantha|Moira|Tessa|Fiona|Victoria|Allison|Ava|Susan|Zira|Hazel|Annette|Clara|Emma|Michelle|Female)\b/i;
    function score(v) {
      var n = v.name, s = 0;
      if (/natural|neural|online/i.test(n)) s += 60;            /* Edge / Windows neural voices */
      if (/premium|enhanced|siri/i.test(n)) s += 55;            /* Apple downloaded voices */
      if (/^Google (UK|US|AU)/i.test(n)) s += 40;               /* Chrome's cloud voices */
      if (/compact|espeak|fred|albert|zarvox|trinoids|whisper|bad news|bells|boing|bubbles|cellos|jester|organ|superstar|wobble|grandma|grandpa|rocko|shelley|eddy|flo|reed|sandy/i.test(n)) s -= 80; /* novelty & robotic voices */
      if (/en[-_]NZ/i.test(v.lang) || /New Zealand/i.test(n)) s += 40; else if (/en[-_]AU/i.test(v.lang)) s += 25; else if (/en[-_]GB/i.test(v.lang)) s += 15; else if (/en[-_]US/i.test(v.lang)) s += 6;
      if (MALE.test(n) && !/female/i.test(n)) s += 45; else if (FEMALE.test(n)) s -= 20;
      if (v.localService === false) s += 4;
      return s;
    }
    vs.sort(function (a, b) { return score(b) - score(a); });
    voice = vs[0] || null;
  }
  if (synth) { pickVoice(); if ('onvoiceschanged' in synth) synth.onvoiceschanged = pickVoice; }
  function speak(text) {
    if (typeof clipPlaying !== 'undefined' && clipPlaying) { try { clipPlaying.onended = clipPlaying.onerror = null; clipPlaying.pause(); } catch (e) {} clipPlaying = null; }
    if (!synth) { resumeRec(); return; }
    speaking = true;
    pauseRec();
    synth.cancel();
    var u = new SpeechSynthesisUtterance(text);
    if (voice) u.voice = voice;
    u.lang = voice ? voice.lang : 'en-AU';
    u.rate = 1.02; u.pitch = 1;
    u.onend = u.onerror = function () { speaking = false; resumeRec(); };
    synth.speak(u);
  }
  /* ---- Andy's recorded clips (set in the section settings); fall back to the browser voice ---- */
  var CLIPS = window.__acrVoice || {}, clipCache = {}, clipPlaying = null;
  Object.keys(CLIPS).forEach(function (k) { if (CLIPS[k]) { var a = new Audio(); a.preload = 'auto'; a.src = CLIPS[k]; clipCache[k] = a; } });
  function say(key, text, then) {
    var a = clipCache[key];
    if (!a) { speak(text); if (then) setTimeout(then, 0); return; }
    if (synth) synth.cancel();
    if (clipPlaying) { try { clipPlaying.pause(); } catch (e) {} }
    speaking = true; pauseRec();
    clipPlaying = a;
    try { a.currentTime = 0; } catch (e) {}
    var done = function () { a.onended = a.onerror = null; clipPlaying = null; speaking = false; if (then) then(); else resumeRec(); };
    a.onended = a.onerror = done;
    var pr = a.play(); if (pr && pr.catch) pr.catch(function () { done(); speak(text); });
  }
  function hush() { if (clipPlaying) { try { clipPlaying.pause(); } catch (e) {} clipPlaying = null; } if (synth) synth.cancel(); speaking = false; resumeRec(); }

  /* ---- speech in ---- */
  function makeRec() {
    var r = new SR();
    r.lang = /^en/i.test(navigator.language || '') ? navigator.language : 'en-AU';
    r.continuous = true;
    r.interimResults = false;
    r.maxAlternatives = 3;
    r.onresult = function (e) {
      for (var i = e.resultIndex; i < e.results.length; i++) {
        if (!e.results[i].isFinal) continue;
        var alts = [];
        for (var k = 0; k < e.results[i].length; k++) alts.push(e.results[i][k].transcript.toLowerCase().trim());
        command(alts.join(' | '));
      }
    };
    r.onend = function () { recActive = false; setVoiceUI(); if (voiceOn && !speaking && !cm.hidden) setTimeout(startRec, 250); };
    r.onerror = function (e) {
      if (e.error === 'not-allowed' || e.error === 'service-not-allowed') { micBlocked = true; voiceOn = false; setVoiceUI(); }
    };
    return r;
  }
  function startRec() {
    if (!SR || !voiceOn || recActive || speaking || cm.hidden) return;
    try { rec = rec || makeRec(); rec.start(); recActive = true; } catch (err) {}
    setVoiceUI();
  }
  function pauseRec() { if (rec && recActive) { try { rec.abort(); } catch (err) {} recActive = false; setVoiceUI(); } }
  function resumeRec() { if (voiceOn && !cm.hidden) setTimeout(startRec, 300); }

  /* listen-only feedback: a soft tick and a "heard" pill instead of reading every step out */
  function chime(f) {
    if (!audio) return;
    try {
      var o = audio.createOscillator(), g = audio.createGain(), at = audio.currentTime;
      o.type = 'sine'; o.frequency.value = f || 880;
      g.gain.setValueAtTime(0.0001, at); g.gain.exponentialRampToValueAtTime(0.12, at + 0.015); g.gain.exponentialRampToValueAtTime(0.0001, at + 0.18);
      o.connect(g); g.connect(audio.destination); o.start(at); o.stop(at + 0.2);
    } catch (e) {}
  }
  var heardT = null;
  function heard(txt) {
    var el = $('.acm__heard'); if (!el) return;
    el.innerHTML = I.mic + '<span>' + txt + '</span>';
    el.classList.remove('is-on'); void el.offsetWidth; el.classList.add('is-on');
    clearTimeout(heardT); heardT = setTimeout(function () { el.classList.remove('is-on'); }, 1600);
  }
  function command(t) {
    if (timers.length && /\b(add|plus|extra|take off|take away|minus|knock off|make it)\b/.test(t) && /\b(minutes?|mins?|hours?|seconds?|make it)\b/.test(t) && adjustByVoice(t)) return;
    if (/\b(close (the )?ingredients|hide ingredients)\b/.test(t)) { heard(acT('ac.js.cook_mode.heard_ingredients_closed', 'Ingredients closed')); return toggleIng(false); }
    if (/\b(stop cooking|close cook|exit|close)\b/.test(t)) return closeCook();
    if (/\b(go back|back|previous|last step)\b/.test(t)) { heard(acT('ac.js.cook_mode.heard_going_back', 'Going back')); chime(520); return back(true); }
    if (/\b(repeat|again|say that|what was that|pardon|read (it|that|the step|out|aloud))\b/.test(t)) { heard(acT('ac.js.cook_mode.heard_reading_step', 'Reading this step')); return speak(stepSpeech()); }
    if (/\bingredient/.test(t)) { heard(acT('ac.js.cook_mode.ingredients', 'Ingredients')); return toggleIng(true); }
    if (/\btimer\b/.test(t)) return timerByVoice(t);
    if (/\b(imperial|pounds|ounces|cups)\b/.test(t)) { A.setSystem && A.setSystem('imperial'); return speak(prefsSentence()); }
    if (/\b(metric|grams|kilos|kilograms)\b/.test(t)) { A.setSystem && A.setSystem('metric'); return speak(prefsSentence()); }
    var pm = t.match(/\b(\d+|one|two|three|four|five|six|seven|eight|nine|ten|twelve|twenty)\s*(people|person|persons|serves|servings|of us)\b/);
    if (pm && getPrefs().base) { A.setServes(WORDS[pm[1]] || parseInt(pm[1], 10)); return speak(prefsSentence()); }
    if (setup && /\b(start|ready|yes|yeah|yep|correct|right|let'?s go|let'?s cook)\b/.test(t)) { heard(acT('ac.js.cook_mode.heard_lets_cook', 'Let’s cook')); chime(880); return next(true); }
    if (/\b(stop|quiet|pause|shush|silence|shut up)\b/.test(t)) return hush();
    if (/\b(next|done|continue|go on|carry on|finished|okay|ok)\b/.test(t)) { heard(acT('ac.js.cook_mode.next_step', 'Next step')); chime(880); return next(true); }
  }

  /* ---- timers ---- */
  var WORDS = { a: 1, an: 1, one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9, ten: 10, eleven: 11, twelve: 12, fifteen: 15, twenty: 20, 'twenty five': 25, thirty: 30, forty: 40, 'forty five': 45, fifty: 50, sixty: 60, ninety: 90 };
  var NUMW = 'twenty five|forty five|an?|one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve|fifteen|twenty|thirty|forty|fifty|sixty|ninety';
  /* \b at the start stops words like "pan" being read as "an", and a number glued to letters (e.g. "x10") being read */
  var TRE = new RegExp('(?:^|[^\\w.])(\\d+(?:\\.\\d+)?|' + NUMW + ')(?:\\s*(?:-|–|—|to|or)\\s*(\\d+(?:\\.\\d+)?|' + NUMW + '))?\\s*(hours?|hrs?|minutes?|mins?|seconds?|secs?)\\b', 'gi');
  function num(w) { w = String(w).toLowerCase().replace(/\s+/g, ' '); return WORDS[w] != null ? WORDS[w] : parseFloat(w); }
  /* rewrite friendly phrases into plain numbers before reading times */
  function normTimes(s) {
    return String(s)
      .replace(/(\d+)\s*-\s*(\d+)\s*-\s*(minute|hour|second)/gi, '$1-$2 $3')                    /* 10-15-minute */
      .replace(/(\d+)\s*-\s*(minute|hour|second)/gi, '$1 $2')                                    /* 10-minute */
      .replace(/(\d+)\s*(?:and\s*)?(?:a\s+)?(?:½|1\/2|half)\s*(?:an?\s+)?(hours?|hrs?|minutes?|mins?)/gi, function (m, n, u) { return (+n + 0.5) + ' ' + u; })
      .replace(/(\d+)\s*¼\s*(hours?|hrs?)/gi, function (m, n, u) { return (+n + 0.25) + ' ' + u; })
      .replace(/(\d+)\s*¾\s*(hours?|hrs?)/gi, function (m, n, u) { return (+n + 0.75) + ' ' + u; })
      .replace(/\b(an?|one)\s+(hour|minute)\s+and\s+a\s+half\b/gi, function (m, a, u) { return '1.5 ' + u + 's'; })
      .replace(/\b(\d+|two|three|four|five)\s+and\s+a\s+half\s+(hours?|minutes?)/gi, function (m, n, u) { return (num(n) + 0.5) + ' ' + u; })
      .replace(/(?:½|\bhalf)\s+(?:an?\s+)?hour\b/gi, '30 minutes')
      .replace(/(?:½|\bhalf)\s+(?:a\s+)?minute\b/gi, '30 seconds')
      .replace(/¼\s*(?:of\s+)?(?:an?\s+)?hour\b|\ba\s+quarter\s+(?:of\s+)?an\s+hour\b/gi, '15 minutes')
      .replace(/¾\s*(?:of\s+)?(?:an?\s+)?hour\b|\bthree\s+quarters\s+(?:of\s+)?an\s+hour\b/gi, '45 minutes')
      .replace(/\b(?:a|one)\s+(minute|hour)\s+or\s+(two|so)\b/gi, function (m, u, b) { return b.toLowerCase() === 'two' ? '1-2 ' + u + 's' : '1 ' + u; })
      .replace(/\ba\s+couple\s+(?:of\s+)?(minutes|hours)\b/gi, '2 $1');
  }
  /* a short "what is this timer for" label from the words around the time, e.g. "Simmer the sauce" */
  var LEAD = /\b(for|about|around|approximately|approx|roughly|another|a further|a|an|over|at least|up to|until|or|and|then|every|each)\s*$/i;
  function timerName(text, at, len) {
    var start = Math.max(text.lastIndexOf('. ', at), text.lastIndexOf('! ', at), text.lastIndexOf('? ', at));
    var before = text.slice(start < 0 ? 0 : start + 2, at).trim(), after = text.slice(at + len, at + len + 60);
    for (var k = 0; k < 4; k++) before = before.replace(LEAD, '').replace(/[\s,;:–-]+$/, '').trim();
    var parts = before.split(/,\s*|;\s*|\s+[-–—]\s+|\s+then\s+|\s+and then\s+/i).filter(function (x) { return x.trim(); });
    var seg = (parts[parts.length - 1] || '').trim().replace(/^(then|and|now|next)\s+/i, '');
    var ands = seg.split(/\s+and\s+/i);
    if (ands.length > 1 && ands[ands.length - 1].trim()) seg = ands[ands.length - 1];
    var fm = after.match(/^\s*(?:for|of)\s+(?:the\s+)?([a-z][a-z\s]{2,24}?)(?=[.,;!?]|\s+(?:until|or|and|then|before|while|so)\b|$)/i);
    if (!seg && fm) seg = fm[1];
    seg = seg.replace(/\s+(this|it|them|that|these|everything|the lot|all)$/i, '');
    /* drop trailing "-ing" tails that belong to a different timer, e.g. "Cook for 1 hour stirring" -> "Cook" */
    seg = seg.replace(/\s+(?:for\s+\S+\s+\S+\s+)?(stirring|turning|flipping|basting|checking|shaking|tossing)\b.*$/i, '');
    if (!seg) return '';
    var w = seg.split(/\s+/);
    for (var q = 2; q < w.length; q++) if (/^(in|on|into|onto|over|at|under|inside|until|with)$/i.test(w[q])) { w = w.slice(0, q); seg = w.join(' '); break; }
    if (w.length > 5) seg = w.slice(0, 5).join(' ').replace(/\s+(the|a|an|and|in|on|of|to|with|for|into)$/i, '') + '…';
    return seg.charAt(0).toUpperCase() + seg.slice(1);
  }
  /* "every 10 minutes" style reminders: what to do each time, e.g. "Stir" */
  var V_STIR = acT('ac.js.cook_mode.verb_stir', 'Stir'), V_TURN = acT('ac.js.cook_mode.verb_turn', 'Turn'), V_FLIP = acT('ac.js.cook_mode.verb_flip', 'Flip'), V_BASTE = acT('ac.js.cook_mode.verb_baste', 'Baste'), V_CHECK = acT('ac.js.cook_mode.verb_check', 'Check'), V_SHAKE = acT('ac.js.cook_mode.verb_shake', 'Shake'), V_TOSS = acT('ac.js.cook_mode.verb_toss', 'Toss'), V_ROTATE = acT('ac.js.cook_mode.verb_rotate', 'Rotate'), V_SPRAY = acT('ac.js.cook_mode.verb_spray', 'Spray'), V_MIX = acT('ac.js.cook_mode.verb_mix', 'Mix'), V_SKIM = acT('ac.js.cook_mode.verb_skim', 'Skim');
  var REMIND_VERBS = { stir: V_STIR, stirring: V_STIR, turn: V_TURN, turning: V_TURN, flip: V_FLIP, flipping: V_FLIP, baste: V_BASTE, basting: V_BASTE, check: V_CHECK, checking: V_CHECK, shake: V_SHAKE, shaking: V_SHAKE, toss: V_TOSS, tossing: V_TOSS, rotate: V_ROTATE, rotating: V_ROTATE, spray: V_SPRAY, mix: V_MIX, mixing: V_MIX, skim: V_SKIM, skimming: V_SKIM };
  function remindName(text, at, len) {
    var s0 = Math.max(0, at - 50), off = at - s0, near = text.slice(s0, at + len + 30).toLowerCase(), best = '', bi = -1;
    Object.keys(REMIND_VERBS).forEach(function (v) { var i = near.search(new RegExp('\\b' + v + '\\b')); if (i > -1 && (bi < 0 || Math.abs(i - off) < Math.abs(bi - off))) { bi = i; best = REMIND_VERBS[v]; } });
    return best || V_CHECK;
  }
  function unitSecs(u) { u = u.toLowerCase(); return /^h/.test(u) ? 3600 : /^m/.test(u) ? 60 : 1; }
  /* returns times in the order they appear: { secs, hi (range top or 0), name, every (true for "every X minutes") }.
     The main timer (first that isn't a reminder) is listed first. */
  function findTimers(text, withNames) {
    var src = normTimes(text), out = [], seen = {}, m;
    TRE.lastIndex = 0;
    while ((m = TRE.exec(src))) {
      var lead = m[0].length - m[0].replace(/^[^\w.]/, '').length, at = m.index + lead, len = m[0].length - lead;
      var mult = unitSecs(m[3]);
      var lo = Math.round(num(m[1]) * mult), hi = m[2] ? Math.round(num(m[2]) * mult) : 0;
      if (hi && hi <= lo) hi = 0;
      if (!(lo >= 10 && lo <= 86400)) continue;
      var every = /\b(every|each)\s*(?:other\s*)?$/i.test(src.slice(Math.max(0, at - 14), at));
      var key = lo + '-' + hi + (every ? 'e' : '');
      if (seen[key]) continue;
      seen[key] = 1;
      var t = { secs: lo, hi: hi, every: every, name: '' };
      if (withNames) {
        if (every) t.name = remindName(src, at, len);
        else {
          var nm = timerName(src, at, len);
          /* short labels like "Cook" or "Set aside" get the section name, e.g. "Cook · Toffee sauce" */
          if (typeof withNames === 'string' && withNames && nm.split(/\s+/).length <= 2) nm = (nm ? nm + ' · ' : '') + withNames.charAt(0).toUpperCase() + withNames.slice(1).toLowerCase();
          t.name = nm;
        }
      }
      out.push(t);
    }
    out.sort(function (a, b) { return (a.every ? 1 : 0) - (b.every ? 1 : 0); });
    return out;
  }
  function human(secs) {
    var h = Math.floor(secs / 3600), m = Math.floor((secs % 3600) / 60), s = secs % 60, parts = [];
    if (h) parts.push(acT('ac.js.cook_mode.unit_hr', '__n__ hr', { n: h })); if (m) parts.push(acT('ac.js.cook_mode.unit_min', '__n__ min', { n: m })); if (s && !h) parts.push(acT('ac.js.cook_mode.unit_sec', '__n__ sec', { n: s }));
    return parts.join(' ');
  }
  /* same parts as human(), written out in full for speech ("1 hour 30 minutes").
     mode 'adj': last part in its singular form ("a 10 minute timer"); mode 'bare': last part as a plain number ("make it 15") */
  function spoken(secs, mode) {
    var h = Math.floor(secs / 3600), m = Math.floor((secs % 3600) / 60), s = secs % 60, parts = [];
    if (h) parts.push(['hours', h]); if (m) parts.push(['minutes', m]); if (s && !h) parts.push(['seconds', s]);
    return parts.map(function (p, i) {
      var last = i === parts.length - 1, n = p[1];
      if (last && mode === 'bare' && n !== 1) return String(n);
      var one = n === 1 || (last && mode === 'adj');
      if (p[0] === 'hours') return one ? acT('ac.js.cook_mode.spoken_hours.one', '__n__ hour', { n: n }) : acT('ac.js.cook_mode.spoken_hours.other', '__n__ hours', { n: n });
      if (p[0] === 'minutes') return one ? acT('ac.js.cook_mode.spoken_minutes.one', '__n__ minute', { n: n }) : acT('ac.js.cook_mode.spoken_minutes.other', '__n__ minutes', { n: n });
      return one ? acT('ac.js.cook_mode.spoken_seconds.one', '__n__ second', { n: n }) : acT('ac.js.cook_mode.spoken_seconds.other', '__n__ seconds', { n: n });
    }).join(' ');
  }
  /* "10–15 min", "1–1.5 hr" etc. */
  function rangeLabel(lo, hi) {
    if (!hi) return human(lo);
    if (lo % 60 === 0 && hi % 60 === 0 && hi < 3600) return acT('ac.js.cook_mode.unit_min', '__n__ min', { n: (lo / 60) + '–' + (hi / 60) });
    if (lo % 1800 === 0 && hi % 1800 === 0 && lo >= 3600) return acT('ac.js.cook_mode.unit_hr', '__n__ hr', { n: (lo / 3600) + '–' + (hi / 3600) });
    return human(lo) + ' – ' + human(hi);
  }
  function clock(secs) {
    secs = Math.max(0, Math.ceil(secs));
    var h = Math.floor(secs / 3600), m = Math.floor((secs % 3600) / 60), s = secs % 60;
    return (h ? h + ':' + (m < 10 ? '0' : '') : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }
  var timers = [], tick = null, tid = 0;
  function escH(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* opts: { hi: range top in secs, every: true for a repeating reminder } */
  function startTimer(secs, name, stepNo, opts, quiet) {
    opts = opts || {};
    ensureAudio();
    var t = { id: ++tid, secs: secs, label: human(secs), name: name || '', step: stepNo || 0, end: Date.now() + secs * 1000, done: false, hi: opts.every ? 0 : (opts.hi || 0), every: !!opts.every };
    timers.push(t);
    if (!tick) tick = setInterval(updateTimers, 500);
    updateTimers();
    if (voiceOn && !quiet) {
      var line = t.every ? acT('ac.js.cook_mode.say_remind_set', 'Okay, I’ll remind you to __action__ every __time__.', { action: (t.name || V_CHECK).toLowerCase(), time: spoken(secs) })
        : acT('ac.js.cook_mode.say_timer_set', 'Timer set for __time__.', { time: spoken(secs) }) + (t.hi ? ' ' + acT('ac.js.cook_mode.say_make_it_hint', 'Say “make it __time__” if it needs longer.', { time: spoken(t.hi, 'bare') }) : '');
      if (opts.more) line += ' ' + opts.more;
      say(t.hi || t.every || opts.more ? 'timer_set_x' : 'timer_set', line);
    }
    return t;
  }
  /* +/- time on a running timer (or the newest one) */
  function adjustTimer(t, delta) {
    if (!t) return false;
    var now = Date.now();
    if (t.done) { t.done = false; t.end = now; }
    var left = Math.max(0, t.end - now) + delta * 1000;
    if (left < 1000) left = 1000;
    t.end = now + left;
    t.secs = Math.max(Math.min(t.secs, 60), t.secs + delta);   /* label never drops below a minute */
    t.label = human(t.secs);
    updateTimers(); alertSync();
    return true;
  }
  function extendToTop(t) {
    if (!t || !t.hi) return false;
    var extra = t.hi - t.secs; t.hi = 0;
    return adjustTimer(t, extra);
  }
  function newestTimer() { for (var i = timers.length - 1; i >= 0; i--) if (!timers[i].every) return timers[i]; return timers[timers.length - 1]; }
  var I_MINUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12h12"/></svg>', I_PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12h12M12 6v12"/></svg>';
  function updateTimers() {
    var now = Date.now();
    timers.forEach(function (t) {
      if (!t.done && now >= t.end) { t.done = true; alarm(t); }
    });
    var html = timers.map(function (t) {
      var tag = (t.step ? acT('ac.js.cook_mode.step_n', 'Step __n__', { n: t.step }) + (t.name ? ' · ' : '') : '') + (t.every ? acT('ac.js.cook_mode.action_every', '__action__ every __time__', { action: t.name || V_CHECK, time: t.label }) : t.name);
      var who = escH(t.every ? (t.name || acT('ac.js.cook_mode.reminder', 'reminder')) : (t.name || t.label));
      var ctl = t.done ? '' :
        '<span class="act-timer__adj">' +
          (t.hi ? '<button type="button" class="act-timer__top" data-timer-top="' + t.id + '" aria-label="' + acT('ac.js.cook_mode.make_timer_aria', 'Make the __name__ timer __time__', { name: who, time: escH(human(t.hi)) }) + '">' + acT('ac.js.cook_mode.make_it', 'Make it __time__', { time: escH(human(t.hi)) }) + '</button>' : '') +
          '<button type="button" data-timer-adj="' + t.id + '" data-d="-60" aria-label="' + acT('ac.js.cook_mode.minute_less_aria', 'One minute less on __name__ timer', { name: who }) + '">' + I_MINUS + '<i>1</i></button>' +
          '<button type="button" data-timer-adj="' + t.id + '" data-d="60" aria-label="' + acT('ac.js.cook_mode.minute_more_aria', 'One minute more on __name__ timer', { name: who }) + '">' + I_PLUS + '<i>1</i></button>' +
        '</span>';
      return '<div class="act-timer' + (t.done ? ' is-done' : '') + (tag ? ' has-name' : '') + (t.every ? ' is-every' : '') + '">' + I.clock +
        '<span class="act-timer__txt">' + (tag ? '<span class="act-timer__n">' + escH(tag) + '</span>' : '') +
        '<span class="act-timer__l" data-tl="' + t.id + '">' + (t.done ? (t.every ? acT('ac.js.cook_mode.time_to_action', 'Time to __action__!', { action: (t.name || V_CHECK).toLowerCase() }) : acT('ac.js.cook_mode.timer_label_done', '__time__ done!', { time: t.label })) : clock((t.end - now) / 1000)) + '</span></span>' + ctl +
        '<button type="button" class="act-timer__x" data-timer="' + t.id + '" aria-label="' + (t.done ? acT('ac.js.cook_mode.dismiss_timer_aria', 'Dismiss __name__ timer', { name: who }) : acT('ac.js.cook_mode.cancel_timer_aria', 'Cancel __name__ timer', { name: who })) + '">' + I.close + '</button></div>';
    }).join('');
    /* rebuild only when the set of timers/buttons changes; otherwise just tick the clocks, so taps on +/- never get lost */
    var skel = html.replace(/(data-tl="\d+">)[^<]*/g, '$1');
    function paint(el, h, k) {
      if (!el) return;
      if (el.__k !== k) { el.innerHTML = h; el.__k = k; return; }
      timers.forEach(function (t) { var s = el.querySelector('[data-tl="' + t.id + '"]'); if (s && !t.done) s.textContent = clock((t.end - now) / 1000); });
    }
    paint($('.acm__running'), html, skel);
    paint(float, cm.hidden ? html : '', cm.hidden ? skel : '');
    /* keep the floating timers above Raptive's sticky footer ad */
    if (cm.hidden && timers.length) {
      var ad = document.querySelector('.adthrive-footer'), adh = 0;
      if (ad && ad.offsetHeight) { var top = ad.getBoundingClientRect().top; if (top < window.innerHeight) adh = Math.round(window.innerHeight - top); }
      if (float.__ad !== adh) { float.style.setProperty('--act-ad', adh + 'px'); float.__ad = adh; }
    }
    if (!timers.length && tick) { clearInterval(tick); tick = null; }
  }
  function removeTimer(id) { timers = timers.filter(function (t) { return t.id !== id; }); updateTimers(); alertSync(); }
  function timerById(id) { for (var i = 0; i < timers.length; i++) if (timers[i].id === id) return timers[i]; return null; }
  /* "Got it" on the alert: one-off timers are cleared, reminders start their next round */
  function ackDone() {
    var now = Date.now();
    timers = timers.filter(function (t) {
      if (!t.done) return true;
      if (t.every) { t.done = false; t.end = now + t.secs * 1000; return true; }
      return false;
    });
    updateTimers(); alertSync();
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var b = e.target.closest('[data-timer]');
    if (b) { e.stopPropagation(); return removeTimer(+b.getAttribute('data-timer')); }
    var a = e.target.closest('[data-timer-adj]');
    if (a) { e.stopPropagation(); return adjustTimer(timerById(+a.getAttribute('data-timer-adj')), +a.getAttribute('data-d')); }
    var tp = e.target.closest('[data-timer-top]');
    if (tp) { e.stopPropagation(); return extendToTop(timerById(+tp.getAttribute('data-timer-top'))); }
  }, true);
  function ensureAudio() {
    try { if (!audio) audio = new (window.AudioContext || window.webkitAudioContext)(); if (audio.state === 'suspended') audio.resume(); } catch (err) {}
  }
  function beep() {
    if (!audio) return;
    try { if (audio.state === 'suspended') audio.resume(); } catch (e) {}
    for (var i = 0; i < 6; i++) {
      var o = audio.createOscillator(), g = audio.createGain(), at = audio.currentTime + i * 0.35;
      o.type = 'sine'; o.frequency.value = i % 2 ? 660 : 880;
      g.gain.setValueAtTime(0.0001, at); g.gain.exponentialRampToValueAtTime(0.35, at + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, at + 0.28);
      o.connect(g); g.connect(audio.destination); o.start(at); o.stop(at + 0.3);
    }
  }
  /* ---- "time's up" alert: full-screen flash + shake, vibration (Android), repeating beeps until dismissed ---- */
  var alertEl = null, ring = null, ringCount = 0, title0 = document.title, titleFlip = null;
  function buzz() { if (navigator.vibrate) { try { navigator.vibrate([400, 160, 400, 160, 400, 160, 700]); } catch (e) {} } }
  function alertSync() {
    var due = timers.filter(function (t) { return t.done; });
    if (!due.length) {
      if (alertEl) { alertEl.remove(); alertEl = null; }
      if (ring) { clearInterval(ring); ring = null; }
      if (titleFlip) { clearInterval(titleFlip); titleFlip = null; document.title = title0; }
      if (navigator.vibrate) { try { navigator.vibrate(0); } catch (e) {} }
      document.documentElement.classList.remove('act-ringing');
      return;
    }
    if (!alertEl) {
      alertEl = document.createElement('div');
      alertEl.className = 'act-alert';
      alertEl.setAttribute('role', 'alertdialog');
      alertEl.setAttribute('aria-live', 'assertive');
      document.body.appendChild(alertEl);
      alertEl.addEventListener('click', function (e) {
        var more = e.target.closest('[data-act-more]');
        if (more) { var mt = timerById(+more.getAttribute('data-act-more')); if (mt) { mt.done = false; mt.end = Date.now(); adjustTimer(mt, +more.getAttribute('data-d')); } return; }
        if (e.target.closest('[data-act-ok]') || e.target === alertEl) ackDone();
      });
    }
    var names = due.map(function (t) {
      var extra = !t.every ? '<span class="act-alert__more">' +
        (t.hi ? '<button type="button" data-act-more="' + t.id + '" data-d="' + (t.hi - t.secs) + '">' + acT('ac.js.cook_mode.add_to_top', '+__add__ (to __time__)', { add: escH(human(t.hi - t.secs)), time: escH(human(t.hi)) }) + '</button>' : '') +
        '<button type="button" data-act-more="' + t.id + '" data-d="60">' + acT('ac.js.cook_mode.plus_1_min', '+1 min') + '</button></span>' : '';
      var title = t.every ? acT('ac.js.cook_mode.action_now', '__action__ now', { action: t.name || V_CHECK }) : (t.name || acT('ac.js.cook_mode.time_timer', '__time__ timer', { time: t.label }));
      var sub = t.every ? acT('ac.js.cook_mode.again_in', 'Again in __time__', { time: t.label }) : (t.step ? acT('ac.js.cook_mode.step_n', 'Step __n__', { n: t.step }) + ' · ' : '') + t.label;
      return '<li><b>' + escH(title) + '</b><span>' + escH(sub) + '</span>' + extra + '</li>';
    }).join('');
    alertEl.innerHTML = '<div class="act-alert__card"><span class="act-alert__ico">' + I.clock + '</span><p class="act-alert__k">' + acT('ac.js.cook_mode.times_up', 'Time’s up!') + '</p><ul class="act-alert__list">' + names + '</ul><button type="button" class="act-alert__ok" data-act-ok>' + acT('ac.js.cook_mode.got_it', 'Got it') + '</button></div>';
    alertEl.classList.remove('is-shake'); void alertEl.offsetWidth; alertEl.classList.add('is-shake');
    document.documentElement.classList.add('act-ringing');
    var okb = alertEl.querySelector('[data-act-ok]'); if (okb) okb.focus({ preventScroll: true });
    if (!titleFlip) titleFlip = setInterval(function () { document.title = document.title === title0 ? '⏰ ' + acT('ac.js.cook_mode.times_up', 'Time’s up!') : title0; }, 1000);
    if (!ring) {
      ringCount = 0;
      ring = setInterval(function () {
        if (++ringCount > 30) { clearInterval(ring); ring = null; return; }   /* stop nagging after ~2 minutes */
        beep(); buzz();
        if (alertEl) { alertEl.classList.remove('is-shake'); void alertEl.offsetWidth; alertEl.classList.add('is-shake'); }
      }, 4000);
    }
  }
  function alarm(t) {
    buzz();
    beep();
    alertSync();
    if (voiceOn) setTimeout(function () {
      if (t.every) return say('timer_remind', acT('ac.js.cook_mode.say_time_to', 'Time to __action__.', { action: (t.name || V_CHECK).toLowerCase() }));
      say('timer_done', (t.name ? t.name + '. ' : '') + acT('ac.js.cook_mode.say_timer_done', 'Your __time__ timer is done.', { time: spoken(t.secs, 'adj') }) + (t.hi ? ' ' + acT('ac.js.cook_mode.say_add_hint', 'Say “add __time__” if it needs longer.', { time: spoken(t.hi - t.secs) }) : ''));
    }, 2200);
  }
  /* voice: "add a minute", "add five minutes", "take off two minutes", "make it fifteen" */
  var ORD = { first: 0, '1st': 0, second: 1, '2nd': 1, other: 1, next: 1, third: 2, '3rd': 2, fourth: 3, '4th': 3 };
  function adjustByVoice(t) {
    var tm = newestTimer();
    if (!tm) return false;
    var mk = t.match(/\bmake it\s+(\d+(?:\.\d+)?|[a-z]+(?: five)?)\s*(hours?|minutes?|mins?|seconds?)?/);
    if (mk) {
      var n = num(mk[1]); if (isNaN(n)) return false;
      var target = Math.round(n * (mk[2] ? unitSecs(mk[2]) : (tm.secs >= 3600 && n < 10 ? 3600 : 60)));
      heard(acT('ac.js.cook_mode.heard_timer_now', 'Timer now __time__', { time: human(target) }));
      tm.hi = 0; adjustTimer(tm, target - tm.secs);
      speak(acT('ac.js.cook_mode.say_okay_it_is', 'Okay, __time__ it is.', { time: spoken(target) }));
      return true;
    }
    var am = normTimes(t).match(/\b(add|plus|another|extra|more|take off|take away|minus|less|remove|knock off)\b.*?(?:(\d+(?:\.\d+)?|an?|one|two|three|four|five|ten|fifteen|twenty|thirty)\s*)?(hours?|minutes?|mins?|seconds?|secs?)\b/);
    if (!am) return false;
    var amt = Math.round((am[2] ? num(am[2]) : 1) * unitSecs(am[3]));
    var neg = /take|minus|less|remove|knock/.test(am[1]);
    adjustTimer(tm, neg ? -amt : amt);
    heard((neg ? '−' : '+') + human(amt));
    var left = Math.round((tm.end - Date.now()) / 1000);
    var togo = spoken(left >= 60 ? Math.round(left / 60) * 60 : left);
    speak(neg ? acT('ac.js.cook_mode.say_taken_off', 'Taken off __amount__. About __left__ to go.', { amount: spoken(amt), left: togo }) : acT('ac.js.cook_mode.say_added', 'Added __amount__. About __left__ to go.', { amount: spoken(amt), left: togo }));
    return true;
  }
  function timerByVoice(t) {
    if (/\b(make it|add|plus|extra|take off|minus|less)\b/.test(t) && timers.length && adjustByVoice(t)) return;
    var stepNo = setup || finished ? 0 : idx + 1;
    var found = findTimers(t);
    var fm = t.split(' | ')[0].match(/\bfor (?:the |my )?([a-z][a-z ]{2,24})$/);
    if (found.length) return startTimer(found[0].secs, fm && !/minute|hour|second/.test(fm[1]) ? fm[1].charAt(0).toUpperCase() + fm[1].slice(1) : '', stepNo);
    var inStep = finished ? [] : findTimers(steps[idx].text, steps[idx].heading || true);
    if (inStep.length) {
      var om = t.match(/\b(first|1st|second|2nd|other|next|third|3rd|fourth|4th)\b/), pick = om ? ORD[om[1]] : 0;
      var s = inStep[Math.min(pick, inStep.length - 1)];
      var rest = inStep.filter(function (x) { return x !== s; }), more = '';
      if (!om && rest.length) {
        var r = rest[0];
        more = r.every ? acT('ac.js.cook_mode.say_also_reminder', 'There’s also a reminder to __action__ every __time__ in this step. Say “start the second timer” for that.', { action: (r.name || V_CHECK).toLowerCase(), time: spoken(r.secs) })
          : acT('ac.js.cook_mode.say_also_timer', 'There’s also a __time__ timer in this step. Say “start the second timer” for that.', { time: spoken(r.secs, 'adj') });
      }
      return startTimer(s.secs, s.name, stepNo, { hi: s.hi, every: s.every, more: more });
    }
    speak(acT('ac.js.cook_mode.say_how_long', 'How long? Say, for example, set a timer for ten minutes.'));
  }

  /* ---- ingredients ---- */
  function ingredientRows() {
    return [].slice.call(root.querySelectorAll('.acr-ing__list > li')).map(function (li) {
      if (li.classList.contains('acr-ing__heading')) return { heading: li.textContent.trim() };
      return { qty: (li.querySelector('.acr-ing__qty') || {}).textContent || '', name: (li.querySelector('.acr-ing__name') || {}).textContent || '' };
    });
  }
  function fillIngredients() {
    $('.acm__ing ul').innerHTML = ingredientRows().map(function (r) {
      return r.heading ? '<li class="is-heading">' + r.heading + '</li>' : '<li><span>' + r.name + '</span><b>' + r.qty + '</b></li>';
    }).join('');
  }
  function toggleIng(force) {
    var panel = $('.acm__ing'), open = typeof force === 'boolean' ? force : panel.hidden;
    if (open) fillIngredients();
    panel.hidden = !open;
    $('[data-acm="ing"]').setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function readIngredients() {
    toggleIng(true);
    var list = ingredientRows().filter(function (r) { return !r.heading; }).map(function (r) {
      return (r.qty ? r.qty.replace(/ tbsp/, ' tablespoons').replace(/ tsp/, ' teaspoons').replace(/kg\b/, ' kilos').replace(/ml\b/, ' mils').replace(/(\d)g\b/, '$1 grams') + ' ' : '') + r.name;
    });
    speak(acT('ac.js.cook_mode.ingredients', 'Ingredients') + '. ' + list.join('. ') + '.');
  }

  /* ---- servings & units (synced with the page controls) ---- */
  function sysWord(imp) { return imp ? acT('ac.js.cook_mode.imperial_lc', 'imperial') : acT('ac.js.cook_mode.metric_lc', 'metric'); }
  function peopleCount(n) { return n === 1 ? acT('ac.js.cook_mode.people_count.one', '__count__ person', { count: n }) : acT('ac.js.cook_mode.people_count.other', '__count__ people', { count: n }); }
  function prefsSentence() {
    var p = getPrefs(), sys = sysWord(p.system === 'imperial');
    return p.base ? acT('ac.js.cook_mode.prefs_serves', 'You’re cooking for __people__, using __system__ measurements.', { people: peopleCount(p.serves), system: sys }) : acT('ac.js.cook_mode.prefs_system', 'You’re using __system__ measurements.', { system: sys });
  }
  function syncPrefs() {
    var p = getPrefs(), imp = p.system === 'imperial';
    [].slice.call(cm.querySelectorAll('[data-acm="sys-metric"], [data-acm="sys-imperial"]')).forEach(function (b) {
      var on = (b.getAttribute('data-acm') === 'sys-imperial') === imp;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    $('.acm__field--serves').hidden = !p.base;
    $('.acm__serves-out').textContent = p.serves;
    $('[data-acm="serves-"]').disabled = p.serves <= 1;
    $('.acm__setup-q').innerHTML = p.base
      ? acT('ac.js.cook_mode.setup_q_serves_html', 'You’re cooking for <b>__people__</b>, using <b>__system__</b>. Is that right?', { people: peopleCount(p.serves), system: sysWord(imp) })
      : acT('ac.js.cook_mode.setup_q_system_html','You’re using <b>__system__</b> measurements. Is that right?', { system: sysWord(imp) });
    if (!$('.acm__ing').hidden) fillIngredients();
    /* measurements inside the steps follow the metric/imperial switch */
    steps.forEach(function (st, i) { st.text = stepText(stepLis[i]); });
    if (!cm.hidden && !setup && !finished) $('.acm__text').textContent = steps[idx].text;
  }
  root.addEventListener('acr:prefs', syncPrefs);

  /* ---- render & navigation ---- */
  function stepSpeech() {
    if (finished) return acT('ac.js.cook_mode.say_all_done', 'All done. Enjoy!');
    if (setup) return acT('ac.js.cook_mode.before_you_start', 'Before you start') + '. ' + prefsSentence() + ' ' + (SR && voiceOn ? acT('ac.js.cook_mode.say_setup_voice', 'Say start cooking when you’re ready, or say metric, imperial, or a number of people to change it.') : acT('ac.js.cook_mode.say_setup_tap', 'Tap start cooking when you’re ready.'));
    var s = steps[idx], intro = acT('ac.js.cook_mode.step_n', 'Step __n__', { n: idx + 1 }) + '. ';
    if (s.heading && (idx === 0 || steps[idx - 1].heading !== s.heading)) intro = s.heading.charAt(0) + s.heading.slice(1).toLowerCase() + '. ' + intro;
    return intro + s.text;
  }
  var doneTxt = '';
  function render(doSay) {
    var last = idx === steps.length - 1;
    cm.classList.toggle('is-setup', setup);
    if (setup) {
      syncPrefs();
      $('.acm__title').textContent = titleText;
      $('.acm__count').textContent = acT('ac.js.cook_mode.get_ready', 'Get ready');
      $('.acm__progress span').style.width = '0%';
      $('.acm__back').disabled = true;
      $('.acm__next').innerHTML = acT('ac.js.cook_mode.start_cooking', 'Start cooking') + I.right;
      setHint();
      return;
    }
    $('.acm__title').textContent = titleText;
    $('.acm__count').textContent = finished ? acT('ac.js.cook_mode.all_steps_done', 'All steps done') : acT('ac.js.cook_mode.step_x_of_y', 'Step __n__ of __total__', { n: idx + 1, total: steps.length });
    $('.acm__progress span').style.width = (finished ? 100 : (idx / steps.length) * 100) + '%';
    $('.acm__heading--step').textContent = finished ? '' : steps[idx].heading;
    $('.acm__num').innerHTML = finished ? I.tick : String(idx + 1);
    if (finished && !doneTxt) doneTxt = (A.doneLine ? A.doneLine() : acT('ac.js.cook_mode.done_line', 'Now enjoy your fantastic efforts.'));
    if (!finished) doneTxt = '';
    cm.classList.toggle('is-finished', finished);
    if (finished) $('.acm__heading--step').textContent = acT('ac.js.cook_mode.recipe_complete', 'Recipe complete');
    $('.acm__text').textContent = finished ? doneTxt : steps[idx].text;
    var tms = finished ? [] : findTimers(steps[idx].text, steps[idx].heading || true);
    $('.acm__timers').innerHTML = tms.map(function (s) {
      var lbl = s.every ? acT('ac.js.cook_mode.remind_me_every', 'Remind me every __time__', { time: human(s.secs) }) : acT('ac.js.cook_mode.start_timer_chip', 'Start __time__ timer', { time: rangeLabel(s.secs, s.hi) });
      var sub = s.every ? acT('ac.js.cook_mode.action_reminder', '__action__ reminder', { action: s.name || V_CHECK }) : s.name;
      return '<button type="button" class="acm__chip' + (s.every ? ' acm__chip--every' : '') + '" data-start-timer="' + s.secs + '" data-timer-hi="' + (s.hi || 0) + '"' + (s.every ? ' data-timer-every="1"' : '') + ' data-timer-name="' + escH(s.name) + '">' + I.clock + '<span class="acm__chip-t">' + lbl + (sub ? '<small>' + escH(sub) + (s.hi && !s.every ? ' · ' + acT('ac.js.cook_mode.starts_at_lc', 'starts at __time__', { time: escH(human(s.secs)) }) : '') + '</small>' : (s.hi && !s.every ? '<small>' + acT('ac.js.cook_mode.starts_at', 'Starts at __time__', { time: escH(human(s.secs)) }) + '</small>' : '')) + '</span></button>';
    }).join('');
    $('.acm__back').disabled = false;
    $('.acm__next').innerHTML = finished ? acT('ac.js.cook_mode.close', 'Close') + I.close : (last ? acT('ac.js.cook_mode.finish', 'Finish') + I.tick : acT('ac.js.cook_mode.next_step', 'Next step') + I.down);
    setHint();
    setPageIndex(finished ? steps.length : idx, finished);
    /* always start a new step from the top so long instructions are never cut off */
    var stg = $('.acm__stage'); if (stg) stg.scrollTop = 0; cm.scrollTop = 0;
    /* finishing is shown on screen only, no voice */
  }
  function next(viaVoice) {
    if (finished) return closeCook();
    if (setup) { setup = false; idx = 0; render(true); if (!viaVoice) pulse(); return; }
    if (idx < steps.length - 1) { idx++; } else { finished = true; }
    render(true);
    if (!viaVoice) pulse();
  }
  function back() {
    if (setup) return;
    if (finished) { finished = false; } else if (idx > 0) { idx--; } else { setup = true; }
    render(true);
  }
  function pulse() { var t = $('.acm__step'); t.classList.remove('is-in'); void t.offsetWidth; t.classList.add('is-in'); }

  /* ---- voice toggle & hints ---- */
  function setVoiceUI() {
    var b = $('[data-acm="voice"]');
    b.setAttribute('aria-pressed', voiceOn ? 'true' : 'false');
    b.classList.toggle('is-listening', voiceOn && recActive);
    $('.acm__tool--voice .acm__tool-l').textContent = voiceOn ? (recActive ? acT('ac.js.cook_mode.listening', 'Listening') : acT('ac.js.cook_mode.voice_on', 'Voice on')) : acT('ac.js.cook_mode.hands_free', 'Hands-free');
    setHint();
  }
  function setHint() {
    var h = $('.acm__hint');
    if (voiceOn && SR && !micBlocked) {
      /* fun little speech bubble with the words to say (built once, so it doesn't flicker as the mic restarts) */
      if (!h.querySelector('.acm__say')) h.innerHTML =
        '<span class="acm__say"><span class="acm__say-ico">' + I.mic + '</span><span class="acm__say-body">' +
          '<span class="acm__say-k">' + acT('ac.js.cook_mode.listening_say', 'I’m listening, just say…') + '</span>' +
          '<span class="acm__say-cmds"><span>' + acT('ac.js.cook_mode.cmd_next_step', 'Next step') + '</span><span>' + acT('ac.js.cook_mode.cmd_go_back', 'Go back') + '</span><span>' + acT('ac.js.cook_mode.cmd_start_timer', 'Start timer') + '</span><span>' + acT('ac.js.cook_mode.cmd_ingredients', 'Ingredients') + '</span><span>' + acT('ac.js.cook_mode.cmd_read_it_out', 'Read it out') + '</span></span>' +
        '</span></span><span class="acm__privacy">' + acT('ac.js.cook_mode.privacy', 'Your browser handles the voice recognition.') + '</span>';
      h.classList.add('is-say');
      return;
    }
    h.classList.remove('is-say');
    if (micBlocked) h.textContent = acT('ac.js.cook_mode.mic_blocked', 'Microphone is blocked. Allow it in your browser settings, or tap anywhere for the next step.');
    else if (!SR && noSR) h.textContent = acT('ac.js.cook_mode.voice_unsupported', 'Voice commands aren’t supported in this browser. Try Chrome or Safari, or tap anywhere for the next step.');
    else h.textContent = acT('ac.js.cook_mode.tap_hint', 'Tap anywhere or swipe for the next step. Turn on Hands-free to use your voice.');
  }
  var noSR = false;
  function toggleVoice() {
    ensureAudio();
    if (!SR) { noSR = true; voiceOn = false; setVoiceUI(); return; }
    voiceOn = !voiceOn;
    micBlocked = false;
    if (voiceOn) {
      /* listen only: no reading the steps out; a quick two-note chime says the mic is on */
      chime(660); setTimeout(function () { chime(990); }, 130);
      startRec();
    } else { pauseRec(); if (synth) synth.cancel(); speaking = false; chime(440); }
    setVoiceUI();
  }

  /* ---- open / close ---- */
  function footerGap() {
    var f = document.querySelector('.adthrive-footer');
    var h = f && getComputedStyle(f).display !== 'none' ? f.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--acm-foot', Math.round(h) + 'px');
  }
  function openCook() {
    var firstOpen = stepLis.findIndex ? stepLis.findIndex(function (li) { return !li.classList.contains('is-done'); }) : 0;
    finished = false;
    idx = firstOpen < 0 ? 0 : firstOpen;
    setup = firstOpen <= 0;
    root.classList.add('acr--cooking');
    footerGap();
    cm.hidden = false;
    document.documentElement.classList.add('acm-open');
    acquire();
    ensureAudio();
    render(false);
    pulse();
    updateTimers();
    $('.acm__next').focus({ preventScroll: true });
    if (voiceOn) resumeRec();
  }
  function closeCook() {
    var wasFinished = finished;
    if (clipPlaying) { try { clipPlaying.pause(); } catch (e) {} clipPlaying = null; }
    pauseRec();
    if (synth) synth.cancel();
    speaking = false;
    toggleIng(false);
    cm.hidden = true;
    document.documentElement.classList.remove('acm-open');
    root.classList.remove('acr--cooking');
    release();
    updateTimers();
    markNext();
    var cur = stepLis.filter(function (li) { return li.classList.contains('is-next'); })[0];
    if (cur) cur.scrollIntoView({ block: 'center' });
    cookBtn.focus({ preventScroll: true });
    if (wasFinished && A.showDone) { stepLis.forEach(function (li) { li.classList.remove('is-done'); }); markNext(); A.showDone(); }
  }

  /* ---- input ---- */
  cookBtn.addEventListener('click', openCook);
  cm.addEventListener('click', function (e) {
    var a = e.target.closest('[data-acm], [data-start-timer]');
    if (a && a.hasAttribute('data-start-timer')) { e.stopPropagation(); return startTimer(+a.getAttribute('data-start-timer'), a.getAttribute('data-timer-name') || '', setup || finished ? 0 : idx + 1, { hi: +a.getAttribute('data-timer-hi') || 0, every: a.hasAttribute('data-timer-every') }); }
    var act = a && a.getAttribute('data-acm');
    if (act === 'close') return closeCook();
    if (act === 'voice') return toggleVoice();
    if (act === 'ing') return toggleIng();
    if (act === 'ing-close') return toggleIng(false);
    if (act === 'back') return back();
    if (act === 'sys-metric' || act === 'sys-imperial') { if (A.setSystem) A.setSystem(act.slice(4)); return; }
    if (act === 'serves-' || act === 'serves+') { if (A.setServes) A.setServes(getPrefs().serves + (act === 'serves+' ? 1 : -1)); return; }
    if (act === 'next') return next();
    if (act === 'stage' && !swiped && !setup) return next();
  });
  var sx = 0, sy = 0, swiped = false;
  cm.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiped = false; }, { passive: true });
  cm.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5 && $('.acm__ing').hidden) { swiped = true; if (dx < 0) next(); else back(); setTimeout(function () { swiped = false; }, 400); }
  }, { passive: true });
  document.addEventListener('keydown', function (e) {
    if (cm.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); return $('.acm__ing').hidden ? closeCook() : toggleIng(false); }
    if (!$('.acm__ing').hidden) return;                                       /* let the ingredients list scroll */
    var onBtn = e.target.closest && e.target.closest('button');
    /* Right / Down arrow = next step, Left / Up arrow = back a step, wherever the focus is */
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); next(); }
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); back(); }
    else if ((e.key === ' ' || e.key === 'Enter') && !onBtn) { e.preventDefault(); next(); }   /* on a button, Enter presses that button */
  });
  window.addEventListener('resize', function () { if (!cm.hidden) footerGap(); });
})();
